var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalKeys(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27096_173540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
    fill: "url(#paint0_linear_27096_173540)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.80811 9.13656V14.8803C5.80811 14.9765 5.87185 15.0403 5.96811 15.0403H18.0481C18.1444 15.0403 18.2081 14.9765 18.2081 14.8803V9.13656C18.2081 9.04031 18.1444 8.97656 18.0481 8.97656H5.96811C5.87185 8.97656 5.80811 9.04031 5.80811 9.13656ZM6.12811 9.29656H17.8881V14.7203H6.12811V9.29656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31186 9.88867C7.2156 9.88867 7.15186 9.95242 7.15186 10.0487V13.9368C7.15186 14.0331 7.2156 14.0968 7.31186 14.0968C7.40811 14.0968 7.47186 14.0331 7.47186 13.9368V10.0487C7.47186 9.96867 7.39186 9.88867 7.31186 9.88867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47982 11.6172C8.38357 11.6172 8.31982 11.6809 8.31982 11.7772V13.9372C8.31982 14.0334 8.38357 14.0972 8.47982 14.0972C8.57607 14.0972 8.63982 14.0334 8.63982 13.9372V11.7772C8.63982 11.6972 8.57607 11.6172 8.47982 11.6172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47982 9.88867C8.38357 9.88867 8.31982 9.95242 8.31982 10.0487V10.9768C8.31982 11.073 8.38357 11.1368 8.47982 11.1368C8.57607 11.1368 8.63982 11.073 8.63982 10.9768V10.0487C8.63982 9.96867 8.57607 9.88867 8.47982 9.88867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64828 11.6172C9.55203 11.6172 9.48828 11.6809 9.48828 11.7772V13.9372C9.48828 14.0334 9.55203 14.0972 9.64828 14.0972C9.74453 14.0972 9.80828 14.0334 9.80828 13.9372V11.7772C9.80828 11.6972 9.74391 11.6172 9.64828 11.6172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64828 9.88867C9.55203 9.88867 9.48828 9.95242 9.48828 10.0487V10.9768C9.48828 11.073 9.55203 11.1368 9.64828 11.1368C9.74453 11.1368 9.80828 11.073 9.80828 10.9768V10.0487C9.80828 9.96867 9.74391 9.88867 9.64828 9.88867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8319 9.88867C10.7356 9.88867 10.6719 9.95242 10.6719 10.0487V13.9368C10.6719 14.0331 10.7356 14.0968 10.8319 14.0968C10.9281 14.0968 10.9919 14.0331 10.9919 13.9368V10.0487C10.9919 9.96867 10.9119 9.88867 10.8319 9.88867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 9.88867C11.9036 9.88867 11.8398 9.95242 11.8398 10.0487V13.9368C11.8398 14.0331 11.9036 14.0968 11.9998 14.0968C12.0961 14.0968 12.1598 14.0331 12.1598 13.9368V10.0487C12.1598 9.96867 12.0961 9.88867 11.9998 9.88867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1683 11.6172C13.0721 11.6172 13.0083 11.6809 13.0083 11.7772V13.9372C13.0083 14.0334 13.0721 14.0972 13.1683 14.0972C13.2646 14.0972 13.3283 14.0334 13.3283 13.9372V11.7772C13.3283 11.6972 13.2639 11.6172 13.1683 11.6172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1683 9.88867C13.0721 9.88867 13.0083 9.95242 13.0083 10.0487V10.9768C13.0083 11.073 13.0721 11.1368 13.1683 11.1368C13.2646 11.1368 13.3283 11.073 13.3283 10.9768V10.0487C13.3283 9.96867 13.2639 9.88867 13.1683 9.88867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3519 9.88867C14.2556 9.88867 14.1919 9.95242 14.1919 10.0487V13.9368C14.1919 14.0331 14.2556 14.0968 14.3519 14.0968C14.4481 14.0968 14.5119 14.0331 14.5119 13.9368V10.0487C14.5119 9.96867 14.4319 9.88867 14.3519 9.88867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5199 11.6172C15.4236 11.6172 15.3599 11.6809 15.3599 11.7772V13.9372C15.3599 14.0334 15.4236 14.0972 15.5199 14.0972C15.6161 14.0972 15.6799 14.0334 15.6799 13.9372V11.7772C15.6799 11.6972 15.6161 11.6172 15.5199 11.6172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5199 9.88867C15.4236 9.88867 15.3599 9.95242 15.3599 10.0487V10.9768C15.3599 11.073 15.4236 11.1368 15.5199 11.1368C15.6161 11.1368 15.6799 11.073 15.6799 10.9768V10.0487C15.6799 9.96867 15.6161 9.88867 15.5199 9.88867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6883 9.88867C16.5921 9.88867 16.5283 9.95242 16.5283 10.0487V13.9368C16.5283 14.0331 16.5921 14.0968 16.6883 14.0968C16.7846 14.0968 16.8483 14.0331 16.8483 13.9368V10.0487C16.8483 9.96867 16.7839 9.88867 16.6883 9.88867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9598 10.4968C5.05606 10.4968 5.1198 10.4331 5.1198 10.3368V8.2243H7.23167C7.32792 8.2243 7.39167 8.16055 7.39167 8.0643C7.39167 7.96805 7.32792 7.9043 7.23167 7.9043H4.9598C4.86355 7.9043 4.7998 7.96805 4.7998 8.0643V10.3362C4.7998 10.4168 4.86355 10.4968 4.9598 10.4968V10.4968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0398 7.9043H16.7679C16.6717 7.9043 16.6079 7.96805 16.6079 8.0643C16.6079 8.16055 16.6717 8.2243 16.7679 8.2243H18.8798V10.3362C18.8798 10.4324 18.9435 10.4962 19.0398 10.4962C19.136 10.4962 19.1998 10.4324 19.1998 10.3362V8.0643C19.1998 7.9843 19.136 7.9043 19.0398 7.9043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23167 15.7764H5.1198V13.6639C5.1198 13.5677 5.05606 13.5039 4.9598 13.5039C4.86355 13.5039 4.7998 13.5677 4.7998 13.6639V15.9358C4.7998 16.032 4.86355 16.0958 4.9598 16.0958H7.23167C7.32792 16.0958 7.39167 16.032 7.39167 15.9358C7.39167 15.8401 7.31167 15.7764 7.23167 15.7764V15.7764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0398 13.5039C18.9435 13.5039 18.8798 13.5677 18.8798 13.6639V15.7758L16.7679 15.7764C16.6717 15.7764 16.6079 15.8402 16.6079 15.9364C16.6079 16.0327 16.6717 16.0964 16.7679 16.0964H19.0398C19.136 16.0964 19.1998 16.0327 19.1998 15.9364V13.6639C19.1998 13.5839 19.136 13.5039 19.0398 13.5039V13.5039Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27096_173540",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35303E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7799"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27096_173540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalKeys);
export default __webpack_public_path__ + "static/media/total_keys.8042695f93864d85ae478883d3143766.svg";
export { ForwardRef as ReactComponent };